<template>
  <!-- Video Button and Dialog -->
  <AboutDialog />
  <!-- Control buttons in the upper left corner -->
  <div style="position:absolute; left: 0%; top: 75px; height: 100px; width:250px; z-index: 2000;
  display: flex; flex-direction: column; justify-content: center;">
    <el-button type="success" size="large" @click="clickFloatingbutton()"
               style="border-top-left-radius: 0;border-bottom-left-radius: 0;">
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" 
                  style="fill: white; margin-right: 5px; height: 18px">
                <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/>
              </svg>Search</el-button>
    <span style="font-size: 14px; color: white; z-index: 2000; margin-top: 15px; opacity: 0.9;">Line Opacity: {{String(lineOpacityCoef)+'%'}}</span>
    <el-slider v-model="lineOpacityCoef" show-tooltip="false" :step="10" :min="0"
    style="width: 220px;margin: 10px;"/>
  </div>

  <div style="position:absolute;left: 20px;top: 200px;width: 49px;height: 150px;">
    <ul class="tool-bar">
      <li @click="zoomIn">
        <img src="zoomIn.svg" class="tool-img">
      </li>
      <li @click="zoomOut">
        <img src="zoomOut.svg" class="tool-img">
      </li>
      <li @click="fitTheView">
        <img src="fitTheView.svg" class="tool-img">
      </li>
    </ul>
  </div>

  <!-- Legend on the right -->
  <div id="legend-buttons" style="position:absolute;right: 0px;width: 200px;top:20px; height: 50px; z-index: 3;background-color: #202124; z-index: 2000; display: flex; justify-content: center; gap: 0; align-items: center;">
    <el-button size="small" @click="selectAllLegends">Select All</el-button>
    <el-button size="small" @click="deselectAllLegends">Deselect All</el-button>
  </div>
  <div id="legend-container-three" style="position:absolute;right: 0px;width: 200px;top:80px; height: calc(100vh - 100px); z-index: 3;background-color: #202124; z-index: 2000; overflow: auto">
    <el-checkbox-group v-model="selectedCategory" style="height: 100%; width: 100%;display: flex; flex-direction: column; justify-content: space-between;">
      <div v-for="(category,index) in categoryInfo"
           v-bind:key="category.db_category"
           style="height:70px;display: flex; flex-direction: column; justify-content: space-around;"
           class="legend-block">

        <div class="inner-div" style="height: 25px" :id="`legend-obj-${index}`"></div>

        <div style="width: 100%; display:flex; justify-content: center; align-items: center;flex-wrap: wrap; flex-wrap: wrap">
          <el-checkbox :key="category.db_category" :value="category.db_category" style="color: white; font-size: 18px">
            <div style="display:inline-block;white-space: normal;">{{category.short_name?category.short_name:category.db_category}}</div>
          </el-checkbox>
          <el-tooltip
              v-if="category.tooltip"
              effect="light"
              :content="category.tooltip"
              placement="top-end"
          >
            <el-icon color="rgba(255,255,255,0.9)" :size="16" style="padding-left: 4px"><InfoFilled /></el-icon>
          </el-tooltip>
        </div>
      </div>
    </el-checkbox-group>
  </div>

  <div v-loading.fullscreen.lock="fullscreenLoading" id="network-canvas" style="height: 100%;width: 92%;left: 0; margin: 0;padding: 0;overflow: hidden">
  </div>

  <!-- Search Dialog -->
  <el-dialog v-model="dialogVisible" width="70%"
      title="Search Dialog" draggable
  >
    <el-form :model="formData" label-width="15%" v-on:submit.prevent>
      <el-form-item>
        <template v-slot:label>
          <el-tooltip
              effect="light"
              content="Input any 'Disease | Drug | Lab | Procedure' that you are interested in."
              placement="top"
          >
            <span style="display: flex; align-items: center;">Search for:
              <el-icon :size="18"><QuestionFilled /></el-icon>
            </span>
          </el-tooltip>
        </template>
        <el-input v-model="searchInput" placeholder="Disease | Drug | Lab | Procedure" clearable  @keyup.enter="clickSearch" style="width: 90%"/>
        <div style="width: 1%" />
        <el-button type="primary" :icon="Search" @click="clickSearch" style="width: 9%">Search</el-button>
      </el-form-item>

      <el-form-item label="Select your targets:" v-if="treeVisible"  v-loading="treeLoading">
        <!-- Tree Selector Panel -->
        Expand to get related PheCode. All the terms you select will be collected as the target nodes and used as the initial state before the network expansion.
        <el-scrollbar max-height="300px" height="200px" style="width: 100%;">
          <el-tree  :props="treeConfig"
                    :data="treeData"
                    empty-text="No CUI or PheCode found, please modify keywords."
                    node-key="value"
                    :load="handleCuiToPhecode"
                    @check-change="treeDataChange"
                    @check = "treeCheckMethod"
                    lazy
                    show-checkbox
                    check-strictly
                    style="width: 100%">
          </el-tree>
        </el-scrollbar>
      </el-form-item>

      <el-divider  v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0"/>

      <el-form-item v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">
        <template v-slot:label>
          <el-tooltip
              effect="light"
              content="All the IDs of nodes had been selected as target nodes."
              placement="top"
          >
            <span style="display: flex; align-items: center;">Nodes of Interest:
              <el-icon :size="18"><QuestionFilled /></el-icon>
            </span>
          </el-tooltip>
        </template>
        <el-tag v-for="tag in formData.nodeOfInterestIdArray"
            :key="tag"
            class="mx-1"
            closable
            :disable-transitions="false"
            @close="deleteSelectedNodeTag(tag)"
        >{{ tag }}
        </el-tag>
        <el-tag v-if="formData.nodeOfInterestIdArray.length>0" :disable-transitions="false" @click="clickClearTags">Clear Previous</el-tag>
        <el-tag v-for="tag in selectedTreeNodesSet"
            :key="tag"
            class="mx-1"
            :disable-transitions="false"
        >{{ tag }}
        </el-tag>
      </el-form-item>

      <el-form-item v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">
        <template v-slot:label>
          <el-tooltip
              effect="light"
              content="The search depth determines how many levels of connected nodes will be displayed. When depth=1, only nodes directly connected to the center nodes will be shown. When depth=2, nodes connected to those nodes will also be included, and so on."
              placement="top"
          >
            <span style="display: flex; align-items: center;">Search Depth:
              <el-icon :size="18"><QuestionFilled /></el-icon>
            </span>
          </el-tooltip>
        </template>
        <el-input-number v-model="formData.depth" :min="1" :max="6"/>
      </el-form-item>

      <el-form-item label="Min Threshold:" v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">
        <template v-slot:label>
          <el-tooltip
              effect="light"
              content="The cosine similarity threshold between nodes; the network will only display links above this threshold. A higher threshold results in fewer displayed nodes."
              placement="top"
          >
            <span style="display: flex; align-items: center;">Min Threshold:
              <el-icon :size="18"><QuestionFilled /></el-icon>
            </span>
          </el-tooltip>
        </template>
        <el-slider v-model="formData.minThreshold" :min="0" :max="1" :step="0.01" show-input/>
        <div v-if="thresholdInfo">{{ depthThresholdMap.get(formData.depth )}} is recommended.&ensp;</div>
        <div v-if="thresholdInfo">Increase threshold to reduce the number of nodes.</div>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="resetDialogData" type="danger" plain
                   v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">Clear Data</el-button>
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="clickConfirmDialog()"
                   v-if="formData.nodeOfInterestIdArray.length>0 ||selectedTreeNodesSet.size>0">
          Confirm
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import myData from "./test.json"
import {onMounted, reactive, ref, watch} from "vue";
import ForceGraph3D from '3d-force-graph';
import axios from "axios";
import * as THREE from 'three';
import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import {ElMessage, ElIcon} from "element-plus";
import {InfoFilled} from "@element-plus/icons-vue";
import AboutDialog from './components/AboutDialog.vue';

const myGraph = ForceGraph3D({
  controlType: "trackball",
  extraRenderers: [new CSS2DRenderer()]
});

// resize
const resizeGraph = () => {
  if (myGraph) {
    myGraph
      .width(document.body.clientWidth)
      .height(document.body.clientHeight)
  }
}

const resizeLegend= (graphList) => {
  categoryInfo.forEach((category, index) => {
    const canvas = document.getElementById(`legend-obj-${index}`);
    if (canvas) {
      // Initialize independent Three.js scene
      graphList[index].renderer.setSize(canvas.clientWidth, canvas.clientHeight);
      console.log("new size=",canvas.clientWidth, canvas.clientHeight)
      graphList[index].camera.aspect = canvas.clientWidth / canvas.clientHeight;
      graphList[index].camera.updateProjectionMatrix();
      graphList[index].renderer.render(graphList[index].scene, graphList[index].camera);
    }
  })
}

const categoryInfo = reactive([
  {
    "db_category": "Disease Codified",
  },{
    "db_category": "Lab Codified",
  },{
    "db_category": "Procedure Codified",
    "short_name": "PROC Codified",
    "tooltip": "Procedure Codified"
  },{
    "db_category": "Drug Codified",
  },{
    "db_category": "Disease NLP",
  },{
    "db_category": "Lab NLP",
  },{
    "db_category": "Procedure NLP",
    "short_name": "PROC NLP",
    "tooltip": "Procedure NLP"
  },{
    "db_category": "Drug NLP",
  },{
    "db_category": "Chemicals & Drugs NLP",
    "short_name": "CHEM NLP",
    "tooltip": "Chemicals & Drugs NLP"
  },{
    "db_category": "Activities & Behaviors NLP",
    "short_name": "ACTI NLP",
    "tooltip": "Activities & Behaviors NLP"
  },{
    "db_category": "Phenomena NLP",
    "short_name": "PHEN NLP",
    "tooltip": "Phenomena NLP"
  },{
    "db_category": "PHYS NLP",
    "short_name": "PHYS NLP",
    "tooltip": "Physiology NLP"
  },{
    "db_category": '',
    "short_name": "Other",
    "tooltip": "Other CUI"
  },
])
const selectedCategory = ref(categoryInfo.map(item => item.db_category))
const nodeRelativeCategoryMap = ref([])   // Collect Node Relative Categories in need of visibility updates
console.log(selectedCategory)
var colorMap = new Map([
    ["Disease Codified", "#00C6F2"],
    ["Drug Codified",  "#C7A8F0"],
    ["Lab Codified",  "#30E3A4"],
    ["Procedure Codified","#E693CA"],
    ["Disease NLP",  "#2DAACC"],
    ["Drug NLP", "#A822A1"],
    ["Lab NLP",  "#187A1A"],
    ["PHEN", "#8DA0CB"], ["Phenomena NLP", "#8DA0CB"],
    ["PHYS", "#441DF0"], ["PHYS NLP", "#441DF0"],
    ["PROC", "#F20C51"], ["Procedure NLP",  "#F20C51"],
    ["ACTI", "#D5E4ED"], ["Activities & Behaviors NLP", "#D5E4ED"],
    ["CHEM", "#A822A1"], ["Chemicals & Drugs NLP", "#A822A1"],
    ["", "white"]
]);
var shapeMap = new Map([
    ["Disease Codified", "sphere"],
    ["Drug Codified",   "sphere"],
    ["Lab Codified",   "sphere"],
    ["Procedure Codified", "sphere"],
    ["Disease NLP", "cube"],
    ["Drug NLP",  "cube"],
    ["Lab NLP",   "cube"],
    ["PHEN", "cube"], ["Phenomena NLP", "cube"],
    ["PHYS", "cube"], ["PHYS NLP", "cube"],
    ["PROC", "cube"], ["Procedure NLP", "cube"],
    ["ACTI", "cube"], ["Activities & Behaviors NLP", "cube"],
    ["CHEM", "cube"], ["Chemicals & Drugs NLP", "cube"],
    ["", "sphere"]
]);
const edgeMaterial = new THREE.LineBasicMaterial({ color: 0xffffff, linewidth: 1, opacity:0.7}); // White outline
function updateNodeRelativeCategory(networkData){
  let nodeCateMap = new Map()
  networkData.nodes.forEach(node=>{
    nodeCateMap.set(node.id, node.category)
  })
  let dict = new Map()
  networkData.links.forEach(link=>{
    let tmpSet = new Set()
    if(dict.has(link.source)){
      tmpSet = dict.get(link.source)
    }
    tmpSet.add(nodeCateMap.get(link.target))
    dict.set(link.source, tmpSet)

    tmpSet = new Set()
    if(dict.has(link.target)){
      tmpSet = dict.get(link.target)
    }
    tmpSet.add(nodeCateMap.get(link.source))
    dict.set(link.target, tmpSet)
  })
  return dict
}

// Dialog related logic
let dialogVisible = ref(false)
function clickFloatingbutton(){
  dialogVisible.value = true
}


// Search Results
// Search Bar
const treeLoading = ref(false);
const treeVisible = ref(false)
const searchInput = ref(null)
var selectedIdSet = new Set(["C0011860", "PheCode:250"]);
async function clickSearch() {
  treeLoading.value = true;
  treeVisible.value = true;
  await axios.post(`${window.location.href}searchCUIList?keyword=` + searchInput.value)
      .then(async function (res) {
        if (res.data.data.length == 0) {
          // Return Data is null
          ElMessage.info("No CUI or PheCode found, please modify keywords.");
          treeLoading.value = false;
        } else {
          // Return Data is not null
          // Assign Values to Tree
          selectedTreeNodesSet.forEach((item) => {
            formData.nodeOfInterestIdArray.push(item)
          })
          formData.nodeOfInterestIdArray = Array.from(new Set(formData.nodeOfInterestIdArray))
          selectedTreeNodesSet.clear();

          // Data update issue, wait for the display component to update the data
          treeData.value = Array.from(res.data.data, item => ({
            // Similar to a stream, the data returned by the background is processed
            value: item.cui, // Selected item binding value
            label: item.cui + " ( " + item.term + ")",// Text displayed on the label
            leaf: false,// Is it a leaf node
          }))

          treeLoading.value = false;
          treeSelectorVisible.value = true;
        }
      })
      .catch(error => {
        ElMessage.error("Failed request：" + error)
      })
}

const depthThresholdMap = new Map([
  [1,0],
  [2,0.50],
  [3,0.56],
  [4,0.64],
  [5,0.65],
  [6,0.68],
])
var formData = reactive({
  // The displayed node id
  nodeOfInterestIdArray: [],
  // Search depth
  depth: 2,
  // Threshold
  minThreshold: depthThresholdMap.get(2),
})

var thresholdInfo = ref(false);
watch(() => formData.depth,()=>{
  formData.minThreshold = depthThresholdMap.get(formData.depth);
  thresholdInfo.value = true;
},{deep:true,})


// treeData is what is shown by the tree selected
// treeSelectorVisible controls whether the tree selector will be shown
const treeData = ref([]);
const treeSelectorVisible = ref(false)
let treeConfig = reactive({
  label: 'label',
  isLeaf: 'leaf',
})

function handleCuiToPhecode(node,resolve) {
  const cuiToGet = node.data.value
  if(node.level == 1){
    axios.post(`${window.location.href}CuiToPhe?cui=`+cuiToGet)
        .then(res => {
          const nodes = Array.from(res.data.data, item => ({
            // Similar to a stream, the data returned by the background is processed
            value: item.phecode, // Selected item binding value
            label: item.phecode+" ( "+item.term+")",// Text displayed on the label
            leaf: true,// Leaf Nodes
          }))
          // Return the nodes
          resolve(nodes);
        }).catch(error=> {
      ElMessage.error("Failed request:"+error)
    })
  }
}
// For display: Binding with the Tree selector
let selectedTreeNodesSet = reactive(new Set());

function treeDataChange(data,checked){
  // data is the node data clicked in the same format as the incoming data
  if(checked == true){
    selectedTreeNodesSet.add(data.value)
  }else{
    selectedTreeNodesSet.delete(data.value)
  }
}
function treeCheckMethod(data, selected){
  console.log(data,selected)
}

// Tag Operations
function deleteSelectedNodeTag(tag){
  let temp = new Set(formData.nodeOfInterestIdArray)
  temp.delete(tag);
  formData.nodeOfInterestIdArray = Array.from(temp);
}
function clickClearTags() {
  formData.nodeOfInterestIdArray.length = 0;
}
const fullscreenLoading = ref(true)
async function clickConfirmDialog() {
  // Close Dialog, Show loading
  dialogVisible.value = false;
  fullscreenLoading.value = true;
  selectedTreeNodesSet.forEach((item) => {
    formData.nodeOfInterestIdArray.push(item)
  })
  formData.nodeOfInterestIdArray = Array.from(new Set(formData.nodeOfInterestIdArray))
  selectedIdSet.clear();
  selectedIdSet = new Set(formData.nodeOfInterestIdArray);


  await axios.post(`${window.location.href}getSelectedNodes`, formData)
      .then(async function (res) {
        // Clear cache to ensure new data renders correctly
        cacheNodeLabel.clear();
        cacheNodeGeometry.clear();
        cacheEdges.clear();
        nodeRelativeCategoryMap.value = updateNodeRelativeCategory(res.data.data)
        myGraph.graphData(res.data.data)
            .nodeThreeObject(node=>{
              return getNodeThreeObject(node, selectedIdSet, 0)
            })
            .linkThreeObject(link=>{
              return getLinkThreeObject(link, formData.minThreshold, 0.33);
            })
            .linkLabel(link => {
              return `<p class="tooltip">${link.source.term} (${link.source.id}) &larr;&rarr; ${link.target.term} (${link.target.id})  :  ${(link.weight).toFixed(3)}</p>` 
            })
            .warmupTicks(35)
            .cooldownTicks(100)
        // Clear Tree Selector Related Data
        resetDialogTreeSelector();
        let camera = myGraph.cameraPosition();
        setTimeout(()=>{
          myGraph.linkThreeObject(link=>{
            return getLinkThreeObject(link,res.data.data.minThreshold, 0.33);
          })
          fullscreenLoading.value = false;
        },20)
        setTimeout(()=>{
          myGraph.zoomToFit(1000);
          setTimeout(()=>{
            cameraOrigDist = calcDistFromOrig(camera.x,camera.y,camera.z);
          },1005)
        },100)
        if(res.data.code==201){
          ElMessage.info({duration:10*1000,message:res.data.msg})
        }
      })
      .catch(error => {
        ElMessage.error("Failed request:" + error)
      })
}

// Clear Tree Selector Related Data
function resetDialogTreeSelector(){
  searchInput.value = null;
  treeData.value = [];
  treeVisible.value = false;
  selectedTreeNodesSet.clear();
}

// Clear Dialog Data
function resetDialogData(){
  searchInput.value = null;
  formData.nodeOfInterestIdArray.length = 0;
  formData.depth = 2;
  formData.minThreshold = depthThresholdMap.get(formData.depth);
  treeVisible.value = false;
  treeData.value = [];
  selectedTreeNodesSet.clear();
  thresholdInfo.value = false;
}

function nodeSizeFunc(node){
  return node.size*0.5;  
}

/**
 * Calculate the distance between xyz and (0,0,0)
 * Return floating-point
 */
function calcDistFromOrig(x,y,z){
  return Math.sqrt(x*x+y*y+z*z);
}
/**
 * Calculate the distance between two points
 */
function calcDist(node1,node2){
  let distX=  node1.x-node2.x;
  let distY=  node1.y-node2.y;
  let distZ=  node1.z-node2.z;
  return Math.sqrt(distX*distX + distY*distY + distZ*distZ);
}

/**
 * After recording the zoomTOFit, the distance between the camera and the origin (at maximum viewing Angle)
 */
var labelNeedUpdateVisibility = 0;
var cameraOrigDist = 900;
const lineMaterialDash = new THREE.LineDashedMaterial( {
  color: 0xffffff,
  opacity: 0.10,
  linewidth: 1, //Due to limitations of the OpenGL Core Profile with the WebGL renderer on most platforms linewidth will always be 1 regardless of the set value.
  transparent: true,
  dashSize: 2,
  gapSize: 2,
} );
const lineMaterialSolid = new THREE.LineBasicMaterial( {
  opacity: 0.2,
  linewidth: 1, //Due to limitations of the OpenGL Core Profile with the WebGL renderer on most platforms linewidth will always be 1 regardless of the set value.
  transparent: true,
} );

/**
 * Construct Three line objects according to the link source and target.
 * If the value is small and minThreshold, it is displayed as a dashed line
 * @param link
 * @param minThreshold
 */
function getLinkThreeObject(link,minThreshold, opacityCoef){
  let points = [];
  points.push(new THREE.Vector3(link.source.x, link.source.y, link.source.z));
  points.push(new THREE.Vector3(link.target.x, link.target.y, link.target.z));
  let lineMaterial = link.weight<minThreshold? lineMaterialDash : lineMaterialSolid;
  lineMaterial.opacity = link.weight*opacityCoef;
  let line = new THREE.Line(new THREE.BufferGeometry().setFromPoints(points), lineMaterial);
  line.computeLineDistances();
  return line;
}

/**
 * Setup and then Return mesh for each of the nodes
 * @param node Date
 * @param labelVisNodeSizeThreshold The Threshold decided whether the label of a node is visible
 * @returns {Mesh}
 */
const cacheNodeLabel = new Map()
const cacheNodeGeometry = new Map()
const cacheEdges = new Map()
const cacheNodeMaterial = new Map()
colorMap.forEach((color, category) => {
  let nodeMaterial = new THREE.MeshPhysicalMaterial({
    color: colorMap.get(category) ? colorMap.get(category) : 'white',
    side: THREE.FrontSide,
  });
  cacheNodeMaterial.set(category, nodeMaterial)
})

function getNodeThreeObject(node, selectedIdSet, labelVisNodeSizeThreshold){
  // Get or Create Label
  let nodeLabel;
  if(cacheNodeLabel.has(node.id)){
    nodeLabel = cacheNodeLabel.get(node.id)
  }else{
    const labelDiv = document.createElement('div');
    if(selectedIdSet.has(node.id)){
      // TargetNode
      labelDiv.className = "nodehighlight";
    }else{
      // Not Target Node
      labelDiv.className = "nodelabel";
    }
    labelDiv.innerHTML = node.term;
    nodeLabel = new CSS2DObject(labelDiv);
    nodeLabel.position.set(0,0,0);
    cacheNodeLabel.set(node.id, nodeLabel)
  }

  // Get Or create Node Geometry
  let geometry;
  if(cacheNodeGeometry.has(node.id)){
    geometry = cacheNodeGeometry.get(node.id)
  }else {
    let nodeSize = nodeSizeFunc(node);
    // Set Shape of the nodes
    // let nodeSize = Math.log10(node.count)*2+5   // min,max,avg(count)=1,1331254137,2197837

    switch (shapeMap.get(node.category)) {
      case 'cube':
        geometry = new THREE.TetrahedronGeometry(nodeSize * 0.9, 0);
        break;
      case '':
        console.log("is ''")
        geometry = new THREE.SphereGeometry(nodeSize);
        break;
      case 'sphere':
        geometry = new THREE.SphereGeometry(nodeSize);
        break;
    }
    cacheNodeGeometry.set(node.id, geometry)
  }

  let nodeMaterial = cacheNodeMaterial.get(node.category)
  let mesh = new THREE.Mesh(geometry, nodeMaterial);

  if(shapeMap.get(node.category) == 'cube'){
    let edgesGeometry, edges;
    if(cacheEdges.has(node.id, edges)){
      edges = cacheEdges.get(node.id, edges)
    }else{
      edgesGeometry = new THREE.EdgesGeometry(geometry);
      edges = new THREE.LineSegments(edgesGeometry, edgeMaterial);
      cacheEdges.set(node.id, edges)
    }
    mesh.add(edges);
  }

  // TODO: Modify logic to select the closest 40 points + the largest 40 points
  nodeLabel.visible= node.size>=labelVisNodeSizeThreshold?true:false
  if(selectedIdSet.has(node.id)){
    nodeLabel.visible= true
  }

  mesh.add(nodeLabel);
  node.mesh = mesh
  node.nodeLabel = nodeLabel
  return mesh;
}


function isInView(myGraph, node){
  var ele = document.getElementById("network-canvas")
  const ScreenCoords = myGraph.graph2ScreenCoords(node.x,node.y,node.z);
  if ( ScreenCoords.x >= 0 && ScreenCoords.x <= ele.clientWidth &&
      ScreenCoords.y >= 0 && ScreenCoords.y <= ele.clientHeight
  ){
    return true
  }else{
    return false
  }
}


function calcThresholdOfNodeToShow(myGraph, ){
  // Calculate the minimum distance between the camera and all nodes in view;
  var camP = myGraph.cameraPosition();
  const nodes = myGraph.graphData().nodes;
  let NodeDistArray = [];
  let minDistFromNodeToCam = Number.MAX_VALUE;
  let selectedCategorySet = new Set(selectedCategory.value)
  for (let i = 0; i < nodes.length; i++) {
    const node = nodes[i];
    if(isInView(myGraph, node) && selectedCategorySet.has(node.category)){
      // Node is in view, calculate the distance to the camera;
      let distFromNodeToCam = calcDist(node,camP)
      node.dist = distFromNodeToCam;
      if(distFromNodeToCam < minDistFromNodeToCam){
        minDistFromNodeToCam = distFromNodeToCam;
      }
      NodeDistArray.push(node.size);
    }
  }
  // Descend Sorting
  NodeDistArray.sort(function(a,b){  return b-a;});
  // Get the number of nodes to display based on the closest distance and the distance from the camera to the origin when zooming to fit
  let minVisibleNum = 12;
  let maxVisibleNum = Math.round(nodes.length * 0.15);
  maxVisibleNum = maxVisibleNum>80 ? maxVisibleNum : 80;
  let zoomScale = minDistFromNodeToCam/cameraOrigDist;
  let visibleNum = maxVisibleNum;
  if(zoomScale>=0.7){
    visibleNum = minVisibleNum;
  }else if(zoomScale<=0.2){
    visibleNum = maxVisibleNum
  }else{
    visibleNum = Math.round((zoomScale-0.20)*((minVisibleNum-maxVisibleNum)/0.5)+maxVisibleNum);
  }

  // Fix NodeDistArray[visibleNum] is undefined when num of nodes in View less than NodeDistArray.length
  if(visibleNum<NodeDistArray.length){
    return NodeDistArray[visibleNum]
  }else{
    return 0
  }
}

onMounted(()=>{
  // Draw Legend and prepare for resize
  const myGraphList = drawLegend()

  // canvas Adapt to screen size changes
  window.onresize = () => {
    resizeGraph();
    resizeLegend(myGraphList);
  }

  // Draw default Network, set default configurations
  var ele = document.getElementById("network-canvas");
  nodeRelativeCategoryMap.value = updateNodeRelativeCategory(myData)
  myGraph(ele).graphData(myData)
      .width(ele.offsetWidth)
      .height(ele.offsetHeight)
      .numDimensions(3)
      .nodeVal(node=>{
        return node.degree
      })
      .nodeThreeObject(node=>{
        return getNodeThreeObject(node, selectedIdSet, 0)
      })
      .nodeThreeObjectExtend(false)
      .enableNodeDrag(false)
      .onNodeClick(async node => {
        try {
          // Get the complete path
          const apiBase = window.location.pathname;
          // Concatenate the complete API URL
          const response = await fetch(`${apiBase}api/config`);
          
          if (!response.ok) {
            throw new Error('Failed to get configuration');
          }
          const config = await response.json();
          const baseUrl = config.VUE_SHINY_APP_URL || process.env.VUE_APP_URL_SHINY;
          
          if (!baseUrl) {
            throw new Error('No valid Shiny application URL found');
          }
          
          window.open(`${baseUrl}?centernode=${node.id}`);
          
        } catch (error) {
          console.error('Navigation failed:', error);
          ElMessage.error('Navigation failed, please check configuration or contact administrator');
        }
      })
      .backgroundColor('#202124')  // Background color of the canvas
      .nodeLabel(node => {
        return `<p class="tooltip"><b>ID:</b> ${node.id} <br> <b>Term:</b> ${node.term} <br><b>Category:</b> ${node.category}</p>` // `${node.id}: ${node.name}`
      })
      .linkThreeObject(link=>{
        return getLinkThreeObject(link, 0.5, 0.033);
      })
      .linkLabel(link => {
        return `<p class="tooltip">${link.source.term} (${link.source.id}) &larr;&rarr; ${link.target.term} (${link.target.id})  :  ${(link.weight).toFixed(3)}</p>` // `${node.id}: ${node.name}`
      })
      .warmupTicks(35)
      .onEngineStop(()=>{
        console.log("Engine Stop")
      })

  // Update Label visibility and end loading
  setTimeout(()=>{
    fullscreenLoading.value = false;
    updateLabelVisibility();
  },500)

  // Listen for canvas updates and then update Label visibility
  if(document.getElementById("network-canvas")){
    var targetCanvasDom = ele.firstChild.firstChild.firstChild.childNodes[1]
    const callback = function (mutationsList,) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          labelNeedUpdateVisibility = 1;
          break;
        }
      }
    };

    // Observer configuration (what changes need to be observed)
    const config = { attributes: true, childList: true, subtree: true };
    const observer = new MutationObserver(callback);
    // Observer target base on above config
    observer.observe(targetCanvasDom, config);
  }

  // periodically check and exec updateLabelVisibility if labelNeedUpdateVisibility == 1
  setInterval(()=>{
    if(labelNeedUpdateVisibility==1 && fullscreenLoading.value== false) {
      console.log("updateVisibility");
      updateLabelVisibility();
      labelNeedUpdateVisibility = 0;
    }
  },1000)
})

/**
 * Draw legend on right, Return a graphList containing list of objected of the legend graph for resize
 * @returns {*[]}
 */
function drawLegend(){
  const graphList = []

  // Loop over categoryInfo, get canvas by element-id
  categoryInfo.forEach((category, index) => {
    const canvas = document.getElementById(`legend-obj-${index}`);
    if (canvas) {
      const scene = new THREE.Scene();
      scene.background = new THREE.Color('#202124'); // Change background color
      const camera = new THREE.PerspectiveCamera(50, canvas.clientWidth / canvas.clientHeight, 0.1, 1000);
      const ambientLight = new THREE.AmbientLight(0xcccccc, 1.2);
      scene.add( ambientLight );
      const directionalLight = new THREE.DirectionalLight(0xffffff, 1.5)
      scene.add( directionalLight );

      // Define Geometry
      let geometry, edgesGeometry, edges;
      console.log(category.db_category, ":",shapeMap.get(category.db_category))
      if (shapeMap.get(category.db_category) === 'sphere') {
        geometry = new THREE.SphereGeometry(10, 32, 32);
      } else if (shapeMap.get(category.db_category) === 'cube') {
        geometry = new THREE.TetrahedronGeometry(10, 0);
        edgesGeometry = new THREE.EdgesGeometry(geometry);
        edges = new THREE.LineSegments(edgesGeometry, edgeMaterial);
      }

      // Create Material
      const material = new THREE.MeshPhysicalMaterial({
        color: colorMap.get(category.db_category)?colorMap.get(category.db_category):'white',
        side: THREE.FrontSide,
      });

      // Create Object
      const mesh = new THREE.Mesh(geometry, material);
      scene.add(mesh);
      if(shapeMap.get(category.db_category) === 'cube'){
        mesh.add(edges);
        mesh.rotation.x = Math.PI / 4; // Rotate along x-axis
        mesh.rotation.z = Math.atan2(Math.sqrt(2), -1); // Rotate along z-axis to adjust direction
      }

      // Set Cam Pos.
      camera.position.z = 30;

      // Render
      const renderer = new THREE.WebGLRenderer( { antialias: true } );
      renderer.setSize(canvas.clientWidth, canvas.clientHeight);
      canvas.appendChild(renderer.domElement)
      const animate = () => {
        requestAnimationFrame(animate);
        mesh.rotation.y += 0.02; // Animation effect: object rotation
        renderer.render(scene, camera);
      };
      animate();
      graphList.push({
        camera: camera,
        scene: scene,
        renderer: renderer,
      })
    }
  });
  return graphList
}

/***
 *  update visibility of nodes, links, labels once selectedCategory changes
 */
watch(selectedCategory, ()=>{
  let selectedCategorySet = new Set(selectedCategory.value)
  let tmpRelSet = new Set()
  let leftSelectedRelCategorySet = new Set()
  myGraph.nodeVisibility((node)=>{
    // If all the links of a nodes are invisible <==> the categories of all the nodes connected to this node are not in the selectedCategorySet
    tmpRelSet = nodeRelativeCategoryMap.value.get(node.id)
    leftSelectedRelCategorySet = [...tmpRelSet].filter(id => selectedCategorySet.has(id))
    return selectedCategorySet.has(node.category) && leftSelectedRelCategorySet.length>0
  }).linkVisibility((link)=>{
    return selectedCategorySet.has(link.source.category) && selectedCategorySet.has(link.target.category)
  })
  updateLabelVisibility()
},{deep:true})


/**
 * Update ThreeObject Control Label display and close
 */
function updateLabelVisibility(){
  let VisThreshold = calcThresholdOfNodeToShow(myGraph)

  // Node occlusion detection
  // let camera = myGraph.camera();
  // let posCam = new THREE.Vector3().setFromMatrixPosition( camera.matrixWorld );
  // let posMesh = new THREE.Vector3( node.x, node.y, node.z );
  // let dir = posMesh.clone().sub(posCam).normalize();
  // let rayCaster = new THREE.Raycaster(posCam, dir);
  // let intersects = rayCaster.intersectObjects( myGraph.scene().children);
  // if(intersects.length>0){
  //   console.log(intersects)
  // }

  // Adjust Label Visibility based on previous visibleNum caculated
  myGraph.nodeThreeObject(node=>{
    return getNodeThreeObject(node, selectedIdSet, VisThreshold)
  })
}

/**
 * Auto fit the view
 * With animation and set label that labelNeedUpdateVisibility
 */
function fitTheView(){
  let camera = myGraph.cameraPosition();
  myGraph.zoomToFit(600,0);
  labelNeedUpdateVisibility = 1;
  setTimeout(()=>{
    cameraOrigDist = calcDistFromOrig(camera.x,camera.y,camera.z);
    labelNeedUpdateVisibility = 1;
  },605)
}


/**
 * ZoomIn
 */
function zoomIn(){
  let origPos = myGraph.cameraPosition();
  let newPos = myGraph.cameraPosition();
  let origLookAt = myGraph.cameraPosition().lookAt;
  let newLookAt = myGraph.cameraPosition().lookAt;
  newPos.x = newPos.x - (origPos.x-origLookAt.x)*0.1;
  newPos.y = newPos.y - (origPos.y-origLookAt.y)*0.1;
  newPos.z = newPos.z - (origPos.z-origLookAt.z)*0.1;
  newLookAt.x = origLookAt.x - (origPos.x-newPos.x);
  newLookAt.y = origLookAt.y - (origPos.y-newPos.y);
  newLookAt.z = origLookAt.z - (origPos.z-newPos.z);
  myGraph.cameraPosition(
      newPos, // new position
      newLookAt,
      500  // ms transition duration
      );
  labelNeedUpdateVisibility = 1;
}


/**
 * ZoomOut
 */
function zoomOut(){
  let origPos = myGraph.cameraPosition();
  let newPos = myGraph.cameraPosition();
  let origLookAt = myGraph.cameraPosition().lookAt;
  let newLookAt = myGraph.cameraPosition().lookAt;
  newPos.x = newPos.x + (origPos.x-origLookAt.x)*0.1;
  newPos.y = newPos.y + (origPos.y-origLookAt.y)*0.1;
  newPos.z = newPos.z + (origPos.z-origLookAt.z)*0.1;
  newLookAt.x = origLookAt.x - (origPos.x-newPos.x);
  newLookAt.y = origLookAt.y - (origPos.y-newPos.y);
  newLookAt.z = origLookAt.z - (origPos.z-newPos.z);
  myGraph.cameraPosition(
      newPos, // new position
      newLookAt,
      500  // ms transition duration
  );
  labelNeedUpdateVisibility = 1;
}

/**
 * Line Opacity Related Variables and Functions
 */
const lineOpacityCoef = ref(10)
watch(lineOpacityCoef, ()=>{
  myGraph
    .linkThreeObject(link=>{
      return getLinkThreeObject(link, formData.minThreshold, lineOpacityCoef.value/300);
    })
})

// Add these two functions in script setup
function selectAllLegends() {
  selectedCategory.value = categoryInfo.map(item => item.db_category)
}

function deselectAllLegends() {
  selectedCategory.value = []
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100%;
  margin: 0px;
  padding: 0px;
}

.tooltip {
  z-index: 1000;
  color: rgba(0,0,0,0.9);
  font-size: 14px;
  line-height: 20px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 3px;
  padding: 7px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  box-shadow: rgba(0, 0, 0, 0.2);
  text-align: left;
}
.nodelabel{
  z-index: 0;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255,255,255,0.95);
  padding: 1px 4px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  user-select: none;
}
.nodehighlight{
  z-index: 0;
  font-size: 16px;
  line-height: 22px;
  font-weight: bold;
  text-shadow: 0 0 5px grey;
  color: rgba(255,255,255,0.95);
  padding: 1px 4px;
  border-radius: 4px;
  background-color: rgba(242, 12, 81, 0.7);
  user-select: none;
}
.scene-tooltip{
  z-index: 1000;
}
.tool-bar{
  z-index: 2000;
  position: absolute;
  list-style-type: none;
  padding: 6px;
  background-color: rgba(255, 255, 255, 0.9);
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  margin: 0;
}
.tool-bar li{
  float: left;
  width: 35px;
  height: 35px;
  cursor: pointer;
  display: list-item;
  list-style: none;
  margin-left: 0px;
}
.tool-img{
  margin: 3px;
  height: 1.5rem;
  width: 1.5rem;
  opacity: 0.7;
}
.tool-img:hover{
  opacity: 1;
}
svg{
  width: 100%;
  height: 100%;
}

.el-scrollbar .el-scrollbar__wrap {
  border: 0.5px;
  border-color: #dcdfe6;
  border-style: solid;
}

</style>
